import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/htmlOutput';

export const updatedHtmlBody = createAction(types.UPDATE_HTML_BODY);
export const updatedLoadedStatus = createAction(types.UPDATE_HTML_BODY_LOADED_STATUS);
